import { render } from "./HosPalPreadmissionNotes.vue?vue&type=template&id=c912fbaa&ts=true"
import script from "./HosPalPreadmissionNotes.ts?vue&type=script&lang=ts&external"
export * from "./HosPalPreadmissionNotes.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__